import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContactoScreen() {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [form, setForm] = useState({tipo:'Neuroterapeuta',nombre:'',apellido:'',email:'',mensaje:''});
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');
    setLoading(true);
    if (window.grecaptcha) {
      const recaptcha = await window.grecaptcha.execute('6LfRD8srAAAAAP3dpjpU3KGOzrOJbfgAGTx-KHdG', { action: 'contacto' });
      if (!recaptcha) {
        setErrorMsg('No se pudo validar reCAPTCHA.');
        setLoading(false);
        return;
      }
      // Enviar datos al backend
      try {
        const res = await fetch('https://api.braineka.com/usuarios/contacto', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nombre: form.nombre + ' ' + form.apellido,
            email: form.email,
            mensaje: `[${form.tipo}] ${form.mensaje}`,
            recaptcha
          })
        });
        const data = await res.json();
        if (res.ok && data.ok) {
          setSuccessMsg('Consulta enviada correctamente.');
          setForm({tipo:'Neuroterapeuta',nombre:'',apellido:'',email:'',mensaje:''});
        } else {
          setErrorMsg(data.error || 'Error al enviar la consulta.');
        }
      } catch (err) {
        setErrorMsg('Error de conexión.');
      }
    } else {
      setErrorMsg('No se pudo cargar reCAPTCHA.');
    }
    setLoading(false);
  };

  return (
    <div style={{maxWidth:400,margin:'40px auto',padding:24,background:'#fff',borderRadius:16,boxShadow:'0 2px 16px #f18618, 0 2px 16px #0003'}}>
      <button onClick={()=>navigate('/')} style={{marginBottom:18,background:'linear-gradient(90deg, #0099cc 0%, #1e90ff 100%)',color:'#fff',fontWeight:700,borderRadius:14,border:'none',fontSize:'1rem',padding:'10px 24px',boxShadow:'0 0 8px 2px #0099cc22',cursor:'pointer'}}>← Volver al inicio</button>
      <h2 style={{marginBottom:18}}>Formulario de contacto</h2>
      <form onSubmit={handleSubmit} style={{display:'flex',flexDirection:'column',gap:10,marginTop:12}}>
        <select value={form.tipo} onChange={e=>setForm({...form,tipo:e.target.value})} style={{padding:8,borderRadius:8,border:'1px solid #ccc'}}>
          <option value="Neuroterapeuta">Neuroterapeuta</option>
          <option value="Usuario">Usuario</option>
        </select>
        <input ref={inputRef} required type="text" placeholder="Nombre" value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})} style={{padding:8,borderRadius:8,border:'1px solid #ccc'}} />
        <input required type="text" placeholder="Apellido" value={form.apellido} onChange={e=>setForm({...form,apellido:e.target.value})} style={{padding:8,borderRadius:8,border:'1px solid #ccc'}} />
        <input required type="email" placeholder="Email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} style={{padding:8,borderRadius:8,border:'1px solid #ccc'}} />
        <textarea required placeholder="Escribe tu consulta" value={form.mensaje} onChange={e=>setForm({...form,mensaje:e.target.value})} style={{padding:8,borderRadius:8,border:'1px solid #ccc',minHeight:64}} />
        <button className="btn-blue neon-orange" type="submit" style={{marginTop:8,background:'linear-gradient(90deg, #0099cc 0%, #1e90ff 100%)',color:'#fff',fontWeight:700,borderRadius:14,boxShadow:'0 0 12px 2px #f18618, 0 2px 10px #0099cc22',border:'none',fontSize:'1.08rem',padding:'12px 0',transition:'box-shadow 0.2s'}} disabled={loading}>{loading ? 'Enviando...' : 'Enviar consulta'}</button>
        {errorMsg && <div style={{color:'#d32f2f',marginTop:8,fontWeight:600}}>{errorMsg}</div>}
        {successMsg && <div style={{color:'#388e3c',marginTop:8,fontWeight:600}}>{successMsg}</div>}
      </form>
    </div>
  );
}
